import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { CourseTestManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/courses/$courseId/test")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <CourseTestManagement />
    </RouteGuard>
  ),
});
